import { FlexProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Flex } from '../../../../atoms';

export type MoneyTemplateCardBodyProps = {
  children: ReactNode;
} & FlexProps;

export function MoneyTemplateCardBody({
  children,
  ...rest
}: MoneyTemplateCardBodyProps): JSX.Element {
  return (
    <Flex
      paddingX="10px"
      display="flex"
      flexDir="row"
      gap="10px"
      alignItems="center"
      justifyContent="space-between"
      {...rest}
    >
      {children}
    </Flex>
  );
}
